{
  "dashboard": {},
  "clusterName": {},
  "clusterStatus": {}
}
